export let IsAllow = (allow, action) => {
  if (allow[action] === "true") {
    return true;
  }
  return false;
};

export let ValidatePermission = (user, requiredPermission) => {
  //user permissions is an array of objects with code property and we need to check if every required permission is in the user permissions

  if (user?.role?.sa || user?.role?.admin) {
    return true;
  }

  const userPermissions = user?.permissions || [];

  const hasPermission = requiredPermission.every((permission) =>
    userPermissions?.some(
      (userPermission) => userPermission.code === permission
    )
  );

  return hasPermission;
};
